var _ellipse, _ellipse2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeingHubInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5,
    cy: 24.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_9428_126780)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4998,
    cy: 24.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_9428_126780)",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9428_126780)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5005,
    cy: 12.5,
    r: 12.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.8003,
    cy: 13,
    r: 2.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.8003,
    cy: 7,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.30029,
    cy: 7.5,
    r: 1.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.3008,
    cy: 16.5,
    r: 1.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.0996,
    cy: 19,
    r: 0.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.70068,
    cy: 14.1992,
    r: 0.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 8.59766L12.8291 10.7571",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3013 14.6973L19.1337 15.6724",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6553 16.0078L14.3455 17.9837",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6636 8.43164L16.3654 10.7295",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70068 13.9414L11.8399 13.1005",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9428_126780",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 24.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9428_126780",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4998 24.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9428_126780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(2.00049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingHubInactive);
export default __webpack_public_path__ + "static/media/wellbeing-hub-inactive.dc1be1a407a800406e28968ccaae3459.svg";
export { ForwardRef as ReactComponent };